import styled from 'styled-components';
import media from '../../../../styles/media.style';

export const CareItemListWrap = styled.div`
  color: #000;

  ${media.tabletP`
    min-width: 456px;
  `};
`;

export const CareItemList = styled.div`
  &.recommend {
    .care-item {
      padding: 30px 20px;
      > .care-item-image {
        width: 110px;
      }
      > .care-item-info {
        .care {
          font-size: 12px;

          ${media.tabletP`
            font-size: 14px;
          `};
        }
        .title {
          font-size: 14px;

          ${media.tabletP`
            font-size: 18px;
          `};
        }
        .name {
          font-size: 11px;

          ${media.tabletP`
            font-size: 12px;
          `};
        }
      }
    }
  }
`;

export const CareItem = styled.div`
  color: #000;
  padding: 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dfdfdf;

  &.selected {
    background-color: #e6eaed;
    border: 1px solid #9ca1a4;
  }
`;

export const CareItemImage = styled.div`
  color: #000;
  width: 100px;
  position: relative;
  .recommend {
    position: absolute;
    left: -14px;
    top: -14px;
    width: 90px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 1000px;
    background: #e5e5e5;
    color: #000;
    transform: scale(0.7);
    font-size: 11px;
    box-sizing: border-box;
    border: 2px solid #fff;
  }
  img {
    max-width: 100%;
  }
`;

export const CareItemInfo = styled.div`
  color: #000;
  width: calc(100% -120px);
  margin-left: 20px;

  .care {
    font-size: 12px;
  }

  .title {
    font-size: 14px;
    margin: 5px 0;

    ${media.tabletP`
      font-size: 16px;
    `};
  }

  .name {
    font-size: 11px;
    color: #888888;

    ${media.tabletP`
      font-size: 10px;
    `};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/DiagnosisResultItemListCard/DiagnosisResultItemListCard.style.js